export class IndexCardConfiguration {
    Id: number;
    Width: number;
    Height: number;
    MarginTop: number;
    MarginBottom: number;
    MarginLeft: number;
    MarginRight: number;
    RowHeigh: number;
    PrintLines: boolean;
}



// WEBPACK FOOTER //
// ./src/app/main/models/index-card-configuration/index-card-configuration.ts